const types = {
  LOAD: 'app/contracts/LOAD',
  LOAD_SUCCESS: 'app/contracts/LOAD_SUCCESS',
  LOAD_FAIL: 'app/contracts/LOAD_FAIL',
  RESET: 'app/contracts/RESET',
};

export default types;
